import { render, staticRenderFns } from "./WalletsHistory.vue?vue&type=template&id=fcffc0bc&scoped=true"
import script from "./WalletsHistory.vue?vue&type=script&lang=js"
export * from "./WalletsHistory.vue?vue&type=script&lang=js"
import style0 from "./WalletsHistory.vue?vue&type=style&index=0&id=fcffc0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcffc0bc",
  null
  
)

export default component.exports